import type { ReactNode } from "react"
import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import type { TranslationKey } from "../../../../../localization/translations"

export type HeroStat = Readonly<{
    id: string
    value: ReactNode
    labelId: TranslationKey
    labelFallback: string
}>

type HeroStatsProps = Readonly<{
    stats: ReadonlyArray<HeroStat>
}>

const useStyles = makeStyles()((theme) => ({
    root: {
        gap: "3rem",
        flexWrap: "wrap",
    },
    stat: {
        minWidth: "8rem",
    },
    heroNumber: {
        fontFamily: "'Playfair Display', serif",
        fontWeight: 800,
        fontVariantNumeric: "oldstyle-nums",
        fontSize: "3rem",
        lineHeight: 1.1,
        color: theme.palette.tailwind.slate[800],
    },
    label: {
        color: theme.palette.tailwind.slate[500],
    },
}))

export function HeroStats({ stats }: HeroStatsProps) {
    const { classes } = useStyles()

    return (
        <Stack direction="row" className={classes.root}>
            {stats.map((stat) => (
                <Stack key={stat.id} className={classes.stat}>
                    <Typography className={classes.heroNumber}>{stat.value}</Typography>
                    <LocalizedStrict id={stat.labelId}>
                        <Typography variant="caption" className={classes.label}>
                            {stat.labelFallback}
                        </Typography>
                    </LocalizedStrict>
                </Stack>
            ))}
        </Stack>
    )
}
